import { useState, useEffect, useRef } from "react";
import axios from "axios";
import TablaMRT from "../../features/table/RTable";
import SideMenu from "../../features/sideMenu/SideMenu";
import Activo from "../../assets/img/svg/providers/providerActivo.svg";
import MarkerProveedorActivo from "../../assets/img/svg/providers/markerProveedorActivo.svg";
import MarkerProveedorInactivo from "../../assets/img/svg/providers/markerProveedorInactivo.svg";
import MarkerProveedorEnProceso from "../../assets/img/svg/providers/markerProveedorEnProceso.svg";
import Inactivo from "../../assets/img/svg/providers/providerExpirado.svg";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import Instaladores from "../../assets/img/svg/providers/instaladores.svg";
import Eliminar from "../../assets/img/svg/users/eliminar.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import Documentacion from "../../assets/img/svg/users/documentacion.svg";
import EnProceso from "../../assets/img/svg/providers/providerEnProceso.svg";
import IconActivo from "../../assets/img/svg/providers/vigente.svg";
import IconInactivo from "../../assets/img/svg/providers/expirado.svg";
import IconenProceso from "../../assets/img/svg/providers/Proceso.svg";
import IconInhabilitar from "../../assets/img/svg/providers/Inhabilitar.svg";
import Chincheta from "../../assets/img/svg/providers/chincheta.svg";
import ChinchetaDesactivada from "../../assets/img/svg/providers/chinchetaDisable.svg";
import Persona from "../../assets/img/svg/providers/personasIcon.svg";
import Documento from "../../assets/img/svg/providers/documento.svg";
import Ubicacion from "../../assets/img/svg/providers/ubicacion.svg";
import Anadir from "../../assets/img/svg/anadir.svg";
import Personas from "../../assets/img/svg/providers/personas.svg";
import {
  changeViewProvider,
  deleteProvider,
  updateProvider,
} from "../functions/Functions";
import {
  headCellCenterAlign,
  bodyCellCenterAlign,
  headCellLeftAlign,
} from "../../utils/columnStyles";
import { useNavigate } from "react-router-dom";
import Map from "../../ui/map/Map";
import InstallersDocuments from "./InstallersDocuments";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import CustomButton from "../../ui/button/Button";
import {
  formatEmpresa,
  formatName,
  formatCobertura,
  formatEspecialidades,
  highlightText,
} from "../../utils/functionsFormat";
import { habilitarEmpresa, deshabilitarEmpresa } from "../functions/Providers";
import {
  customNumberFilter,
  customStatusFilter,
  customStringFilter,
  customSpecialtyFilter,
} from "../../features/table/filterFunctions";
import "./Providers.responsive.css";
import { ClickAwayListener, Popper } from "@mui/material";

const Providers = ({
  API_URL,
  installersMap,
  user,
  setUser,
  companies,
  perfiles,
  specialties,
}) => {
  const [data, setData] = useState([]);
  const [dataOriginal, setDataOriginal] = useState([]);
  const [openMenuIndex, setOpenMenuIndex] = useState({ top: 0, left: 0 }); // Estado para el menú desplegable
  const [activeSelectIndex, setActiveSelectIndex] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [tableInstance, setTableInstance] = useState(null);
  const rowIconRefEstado = useRef({});

  const navigate = useNavigate();

  const statusProvider = (empresa, estatus, nombre, estatusEmpresa) => {
    const nombreFormateado = formatEmpresa(nombre);

    let iconPath;
    let message;
    switch (estatus) {
      case "activo":
        iconPath = Activo;
        message = `<p class="text-dialog">
  ${nombreFormateado} será establecida como:<br> 
  <strong>
    <img src="${IconActivo}" alt="vigente" style="width:12px; height:12px; vertical-align:middle; margin-right:5px;" />
    Activo
  </strong><br> 
  Podrás cambiar su estatus en cualquier momento.
</p>`;
        break;
      case "inactivo":
        iconPath = Inactivo;
        message = `<p class="text-dialog">${nombreFormateado} será establecida como:<br> 
        <strong>
         <img src="${IconInactivo}" alt="vigente" style="width:12px; height:12px; vertical-align:middle; margin-right:5px;" />
        Inactivo</strong><br> Podrás cambiar su estatus en cualquier momento. <br> <br> También puedes inhabilitar el proveedor.</p>`;
        break;
      case "proceso de integración":
        iconPath = EnProceso;
        message = `<p class="text-dialog">${nombreFormateado} será establecida como:<br> <strong>
          <img src="${IconenProceso}" alt="vigente" style="width:12px; height:12px; vertical-align:middle; margin-right:5px;" />
        En proceso</strong><br> Podrás cambiar su estatus en cualquier momento.</p>`;
        break;
    }
    confirmDialog({
      html: message,
      icon: "warning",
      iconHtml: "!" /*`<img src="${iconPath}" width="50" height="50" />`*/,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      onConfirm: async () => {
        try {
          const partes = (empresa.nombre || "").trim().split(" ");
          const nombreSeparado = partes[0] || "";
          const apellidosSeparados = partes.slice(1).join(" ") || "";
          const payload = {
            ...empresa,
            nombre: nombreSeparado,
            apellidos: apellidosSeparados || " ",
            estatus: estatus,
            estatusEmpresa: estatusEmpresa,
            habilitada: true,
          };
          await updateProvider(API_URL, payload);
          if (estatus !== "inactivo" && empresa.habilitada === false) {
            await habilitarEmpresa(API_URL, empresa.id);
          }
          setData((prevData) =>
            prevData.map((item) =>
              item.id === empresa.id
                ? {
                    ...item,
                    estatusEmpresa: {
                      ...item.estatusEmpresa,
                      nombre: estatus,
                    },
                    habilitada:
                      estatus !== "inactivo" ? true : empresa.habilitada,
                  }
                : item
            )
          );
          confirmDialog({
            html: "El estatus se actualizó correctamente.",
            icon: "success",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
        } catch (error) {
          console.error("Error al modificar estatus empresa:", error);
        }
      },
      showDenyButton: estatus === "inactivo" ? true : false,
      denyButtonText: "Inhabilitar",
      denyButtonColor: "#EDEDED",
      reverseButtons: false,
      onDeny: async () => {
        confirmDialog({
          html: `
              <p class="text-dialog">
                ¿Seguro que desea inhabilitar esta empresa?<br />
                <strong>
                  <img
                    src="${IconInhabilitar}"
                    alt="inactivo"
                    style="width:12px; height:12px; vertical-align:middle; margin-right:5px;"
                  />
                  Inhabilitar
                </strong>
                <br />
                Sus trabajos asignados serán concluidos y los usuarios asociados a la misma serán eliminados.
              </p>
            `,
          icon: "warning",
          confirmButtonText: "Aceptar",
          mostrarCancelar: true,
          reverseButtons: true,
          onConfirm: async () => {
            try {
              await deshabilitarEmpresa(API_URL, empresa.id);
              setData((prevData) =>
                prevData.map((item) =>
                  item.id === empresa.id
                    ? {
                        ...item,
                        estatusEmpresa: {
                          ...item.estatusEmpresa,
                          nombre: estatus,
                        },
                        habilitada: false,
                      }
                    : item
                )
              );
              confirmDialog({
                html: "El estatus se actualizó correctamente.",
                icon: "success",
                confirmButtonText: "Aceptar",
                mostrarCancelar: false,
              });
            } catch (error) {
              console.error("Error al modificar estatus empresa:", error);
            }
          },
        });
      },
    });
  };

  const arrayViews = user.vistasEmpresas
    .split(",")
    .map((num) => parseInt(num.trim(), 10));

  const fetchData = async () => {
    const response = await axios.post(
      `${API_URL}/api/empresas-por-criterios`,
      {
        Empresa: {
          id: null,
          razonSocial: null,
          rfc: null,
          nombreInstalador: null,
          cobertura: null,
          gafete: null,
        },
      },
      { withCredentials: true }
    );

    const sortedData = response.data;
    const mappedMarkers = sortedData.map((item) => ({
      lat: item.latitude,
      lng: item.longitude,
      icon:
        item?.estatusEmpresa?.nombre === "activo"
          ? MarkerProveedorActivo
          : item?.estatusEmpresa?.nombre === "inactivo"
          ? MarkerProveedorInactivo
          : MarkerProveedorEnProceso,
    }));

    setMarkers(mappedMarkers);
    setData(sortedData);
    setDataOriginal(sortedData);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const confirmDialog = useConfirmDialog();

  const editarEmpresa = async (id) => {
    navigate(`/proveedores/editar/${id}`);
  };

  const eliminarProveedores = (id, nombreEmpresa) => {
    confirmDialog({
      html: `¿Estás seguro de que deseas eliminar el proveedor <b>${nombreEmpresa}</b>?`,
      icon: "warning",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      iconClass: "swal2-delete-icon",
      mostrarCancelar: true,
      onConfirm: async () => {
        try {
          await deleteProvider(API_URL, id);
          confirmDialog({
            html: "El proveedor fue eliminado con éxito.",
            icon: "success",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
        } catch (error) {
          confirmDialog({
            html: `Ocurrió un error al eliminar la empresa.<br>${
              error.response?.data?.message || error.message
            }`,
            icon: "error",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
        }
      },
    });
  };

  const contratoEmpresa = async (id) => {
    navigate(`/proveedores/documentos/${id}`);
  };

  const verInstaladores = async (empresaId) => {
    navigate(`/proveedores/instaladores/${empresaId}`);
  };

  const rowIconRef = useRef([]); // Ref único para cada fila

  const toggleMenuOptions = (index) => {
    setOpenMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const toggleSelect = (index) => {
    setActiveSelectIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const columns = [
    {
      accessorKey: "razonSocial",
      header: "Empresa",
      size: 120,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const search = table.getState().globalFilter;
        const formateado = formatEmpresa(texto);
        return <>{highlightText(formateado, search)}</>;
      },
    },
    {
      accessorKey: "nombre",
      header: "Nombre",
      witdh: 150,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const search = table.getState().globalFilter;
        const formateado = formatName(texto);
        return <>{highlightText(formateado, search)}</>;
      },
    },
    {
      accessorKey: "cobertura",
      header: "Cobertura sin viáticos",
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      //filterFn: "includesString",
      //columnFilterModeOptions: ["fuzzy", "contains", "startsWith", "endsWith"],
      size: 190,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const value = cell.getValue();
        const search = table.getState().globalFilter;
        const texto = formatCobertura(value);
        return <span>{highlightText(texto, search)}</span>;
      },
    },
    {
      accessorKey: "capacidadInstalaciones",
      header: "Capacidad      total",
      size: 130,
      filterFn: customNumberFilter,
      meta: { filterVariant: "numerico" },
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ cell, row }) => {
        const [isEditing, setIsEditing] = useState(false);
        const [inputValue, setInputValue] = useState(cell.getValue());

        const handleSave = async (empresa) => {
          const partes = (empresa.nombre || "").trim().split(" ");
          const nombreSeparado = partes[0] || "";
          const apellidosSeparados = partes.slice(1).join(" ") || "";
          const payloadInstallerNumber = {
            ...empresa,
            nombre: nombreSeparado,
            apellidos: apellidosSeparados || " ",
            capacidadInstalaciones: inputValue,
          };

          await updateProvider(API_URL, payloadInstallerNumber);
          setData((prevData) =>
            prevData.map((item) =>
              item.id === empresa.id
                ? {
                    ...item,
                    capacidadInstalaciones: inputValue,
                  }
                : item
            )
          );

          setIsEditing(false);
        };

        return isEditing ? (
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <input
              type="number"
              value={inputValue}
              style={{ width: "60px", textAlign: "center" }}
              onChange={(e) => setInputValue(Number(e.target.value))}
            />
            <button
              onClick={() => handleSave(row.original)}
              style={{ fontSize: "12px" }}
            >
              OK
            </button>
          </div>
        ) : (
          <span
            onClick={() => setIsEditing(true)}
            style={{ cursor: "pointer", whiteSpace: "nowrap" }}
          >
            {cell.getValue()}
          </span>
        );
      },
    },
    {
      accessorKey: "instalacionesActivas",
      header: "Instalaciones activas",
      size: 150,
      filterFn: customNumberFilter,
      meta: { filterVariant: "numerico" },
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
    },
    {
      accessorKey: "especialidades.nombre",
      header: "Especialidad",
      size: 180,
      filterFn: customSpecialtyFilter,
      meta: { filterVariant: "specialty" },
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ row, table }) => {
        const especialidades = row.original.especialidadesSelec;
        const search = table.getState().globalFilter;
        const texto = formatEspecialidades(especialidades);
        return <>{highlightText(texto, search)}</>;
      },
    },
    {
      accessorKey: "estatusEmpresa.nombre",
      header: "Estatus",
      size: 100,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estatus" },
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ cell, row }) => {
        const value = cell.getValue();
        const estado =
          typeof value === "string" ? value.toLowerCase().trim() : "";

        const icon =
          estado === "activo"
            ? Activo
            : estado === "inactivo" || estado === "no deseado"
            ? Inactivo
            : EnProceso;

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              width: "100%",
            }}
          >
            <img
              ref={(el) => (rowIconRefEstado.current[row.id] = el)}
              src={icon}
              alt={estado}
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
              onClick={() => toggleSelect(row.id)}
            />

            <Popper
              open={activeSelectIndex === row.id}
              anchorEl={rowIconRefEstado.current[row.id]}
              placement="bottom"
              style={{ zIndex: 1302 }}
            >
              <ClickAwayListener onClickAway={() => setActiveSelectIndex(null)}>
                <div
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    minWidth: "150px",
                    padding: "4px 0",
                  }}
                >
                  {(() => {
                    //  Normalización solo para el menú
                    const normalizeForMenu = (s = "") => {
                      const v = String(s).toLowerCase().trim();
                      if (v === "no deseado") return "inactivo";
                      if (
                        v === "en proceso" ||
                        v === "en proceso de integración" ||
                        v === "proceso de integración" ||
                        v === "periodo de prueba"
                      ) {
                        return "proceso de integración";
                      }
                      return v;
                    };

                    const estadoActualMenu = normalizeForMenu(estado);

                    const OPCIONES = [
                      {
                        estado: { id: 1, nombre: "activo" },
                        icon: Activo,
                        label: "Activo",
                      },
                      {
                        estado: { id: 10, nombre: "inactivo" },
                        icon: Inactivo,
                        label: "Inactivo",
                      },
                      {
                        estado: { id: 12, nombre: "proceso de integración" },
                        icon: EnProceso,
                        label: "En proceso",
                      },
                    ];

                    const opcionesVisibles = OPCIONES.filter(
                      (o) =>
                        normalizeForMenu(o.estado.nombre) !== estadoActualMenu
                    );

                    return opcionesVisibles.map(({ estado, icon, label }) => (
                      <div
                        key={estado.id}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          whiteSpace: "nowrap",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          statusProvider(
                            row.original,
                            estado.nombre,
                            row.original.razonSocial,
                            estado
                          );
                          setActiveSelectIndex(null);
                        }}
                      >
                        <img
                          src={icon}
                          alt={label}
                          style={{ width: "20px", height: "20px" }}
                        />
                        {label}
                      </div>
                    ));
                  })()}
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
    {
      header: " ",
      size: 50,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ row }) => (
        <div
          style={{ position: "relative", zIndex: 1000, overflow: "visible" }}
        >
          <button
            ref={(el) => (rowIconRef.current[row.index] = el)}
            onClick={() => toggleMenuOptions(row.index)}
            className="action-icon"
          >
            <img
              src={Ajustes}
              alt="Ajustes"
              style={{ width: "20px", height: "20px" }}
            />
          </button>

          <Popper
            open={openMenuIndex === row.index}
            anchorEl={rowIconRef.current[row.index]}
            placement="bottom-start"
            style={{ zIndex: 1302 }}
          >
            <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
              <div
                className="dropdown-menu-user"
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  padding: "10px",
                  minWidth: "200px",
                }}
              >
                <p onClick={() => contratoEmpresa(data[row.index].id)}>
                  <img src={Documentacion} alt="" /> Documentación
                </p>
                <p onClick={() => editarEmpresa(data[row.index].id)}>
                  <img src={Editar} alt="" /> Editar proveedor
                </p>
                <p
                  onClick={() =>
                    eliminarProveedores(
                      data[row.index].id,
                      data[row.index].razonSocial
                    )
                  }
                >
                  <img src={Eliminar} alt="" /> Eliminar proveedor
                </p>
                {row?.original?.habilitada === true && (
                  <p onClick={() => verInstaladores(data[row.index].id)}>
                    <img src={Instaladores} alt="" /> Ver instaladores
                  </p>
                )}
              </div>
            </ClickAwayListener>
          </Popper>
        </div>
      ),
    },
  ];

  const options = {
    enableColumnActions: true,
    enableSorting: true,
    enableColumnFilters: false,
  };

  // ChinchetaDesactivada
  const items = [
    {
      texto: "Proveedores",
      icon: <img src={Persona} alt="Inicio" />,
      url: "/proveedores/todos",
      chincheta: arrayViews.includes(1) ? (
        <img className="menu-icon-svg" src={Chincheta} alt="Proveedores" />
      ) : (
        <img
          className="menu-icon-svg"
          src={ChinchetaDesactivada}
          alt="Proveedores"
        />
      ),
      onIconClick: () => handleClick(1),
    },
    {
      texto: "Mapa de proveedores",
      icon: <img src={Ubicacion} alt="Inicio" />,
      url: "/proveedores/mapa",
      chincheta: arrayViews.includes(4) ? (
        <img
          className="menu-icon-svg"
          src={Chincheta}
          alt="Mapa de proveedores"
        />
      ) : (
        <img
          className="menu-icon-svg"
          src={ChinchetaDesactivada}
          alt="Mapa de proveedores"
        />
      ),
      onIconClick: () => handleClick(4),
    },
    {
      texto: "Mapa de instaladores",
      icon: <img src={Ubicacion} alt="Inicio" />,
      url: "/proveedores/instaladores/mapa",
      chincheta: arrayViews.includes(3) ? (
        <img
          className="menu-icon-svg"
          src={Chincheta}
          alt="Mapa de instaladores"
        />
      ) : (
        <img
          className="menu-icon-svg"
          src={ChinchetaDesactivada}
          alt="Mapa de instaladores"
        />
      ),
      onIconClick: () => handleClick(3),
    },
    {
      texto: "Documentos Instaladores",
      icon: <img src={Documento} alt="Inicio" />,
      url: "/proveedores/instaladores",
      chincheta: arrayViews.includes(2) ? (
        <img
          className="menu-icon-svg"
          src={Chincheta}
          alt="Documentos instaladores"
        />
      ) : (
        <img
          className="menu-icon-svg"
          src={ChinchetaDesactivada}
          alt="Documentos instaladores"
        />
      ),
      onIconClick: () => handleClick(2),
    },
  ];

  const handleClick = async (num) => {
    // Convertir user.vistasEmpresas a array de números
    let arrayViews = user.vistasEmpresas
      .split(",")
      .map((num) => parseInt(num.trim(), 10));

    // Si el número ya está en el array, mostrar alerta y salir
    if (arrayViews.includes(num)) {
      confirmDialog({
        html: `<p class="text-dialog">La vista ya está incluida. ¿Deseas excluirla?</p>`,
        icon: "warning",
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        onConfirm: async () => {
          arrayViews = arrayViews.filter((n) => n !== num);

          // Si lo eliminamos, actualizar la base de datos y salir
          const viewsTexto = arrayViews.sort((a, b) => a - b).join(",");

          try {
            const response = await changeViewProvider(
              API_URL,
              viewsTexto,
              user.id
            );
            if (response === 200) {
              setUser((prevUser) => ({
                ...prevUser,
                vistasEmpresas: viewsTexto,
              }));
            }
          } catch (error) {
            console.error("Error en la actualización:", error);
          }

          return; // Salir de la función para evitar que se siga ejecutando
        },
      });
    }

    // Si se envía 3 y ya existe 4, eliminar 4 y agregar 3
    if (num === 3 && arrayViews.includes(4)) {
      arrayViews = arrayViews.filter((n) => n !== 4);
    }

    // Si se envía 4 y ya existe 3, eliminar 3 y agregar 4
    if (num === 4 && arrayViews.includes(3)) {
      arrayViews = arrayViews.filter((n) => n !== 3);
    }

    // Agregar el nuevo número
    arrayViews.push(num);

    // Ordenar el array y convertirlo a string
    const sortedArray = arrayViews.sort((a, b) => a - b);
    const viewsTexto = sortedArray.join(",");

    try {
      // Hacer la petición PUT para actualizar el usuario
      await changeViewProvider(API_URL, viewsTexto, user.id).then(
        (response) => {
          if (response === 200) {
            setUser((prevUser) => ({
              ...prevUser,
              vistasEmpresas: viewsTexto,
            }));
          }
        }
      );
    } catch (error) {
      console.error("Error en la actualización:", error);
    }
  };

  return (
    <div className="rs-container" style={{ display: "flex", width: "100%" }}>
      <div className="rs-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={items} className="rs-sidemenu" />
      </div>
      <div
        className="rs-content"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        {/* Contenedor superior */}
        <div className="rs-top" style={{ display: "flex", flex: 1 }}>
          {/* Primera columna del contenedor superior */}
          <div
            className="rs-left"
            style={{
              flex: 1,
              padding: "10px",
              width:
                arrayViews.includes(2) &&
                !arrayViews.includes(3) &&
                !arrayViews.includes(4)
                  ? "100%"
                  : "60%",
            }}
          >
            {arrayViews.includes(2) && (
              <InstallersDocuments
                API_URL={API_URL}
                companies={companies}
                perfiles={perfiles}
                dashboard={true}
              />
            )}
          </div>
          {/* Segunda columna del contenedor superior */}
          <div
            className={`rs-right`}
            style={{
              flex: 1,
              padding: "10px",
              width: "40%",
              display:
                arrayViews.includes(2) &&
                !arrayViews.includes(3) &&
                !arrayViews.includes(4)
                  ? "none"
                  : "block",
            }}
          >
            {arrayViews.includes(3) ? (
              <>
                <h1 className="map-title">Mapa de instaladores</h1>
                <div className="rs-mapWrap">
                  <Map installersStatus={true} markers={installersMap} />
                </div>
              </>
            ) : arrayViews.includes(4) ? (
              <>
                <h1 className="map-title">Mapa de proveedores</h1>
                <div className="rs-mapWrap">
                  <Map markers={markers} zoom={5} />
                </div>
              </>
            ) : null}
          </div>
        </div>

        {/* Contenedor inferior */}
        {arrayViews.includes(1) && (
          <div
            className="rs-bottom"
            style={{ flex: 1, padding: "10px", width: "100%" }}
          >
            <div
              className="rs-actions"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "20px",
              }}
            >
              <h2 style={{ margin: 0 }}>Proveedores</h2>
              <CustomButton
                background={"#223D51"}
                width={"180px"}
                height={"31px"}
                fontSize={"12px"}
                color={"#FFFFFF"}
                text={"Ver todos los proveedores"}
                fontWeight={700}
                fontStyle={"normal"}
                border={"0.5px solid #C3C3C3"}
                icon={true}
                src={Personas}
                iconW={"12px"}
                iconM={"5px"}
                onClick={() => navigate("/proveedores/todos")}
              />
              <CustomButton
                background="#62C776"
                width="126px"
                height="31px"
                fontSize="14px"
                color="#FFFFFF"
                text="Añadir nuevo"
                fontWeight={700}
                fontStyle="normal"
                border={0}
                icon={true}
                src={Anadir}
                iconW="12px"
                iconM="5px"
                onClick={() => navigate("/proveedores/nuevo")}
              />
            </div>
            <div className="rs-tableWrap">
              <TablaMRT
                columns={columns}
                data={data}
                options={options}
                onTableReady={(table) => setTableInstance(table)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Providers;
